// extracted by mini-css-extract-plugin
export default {"header":"Header_header__+VPRz","logo":"Header_logo__mtyex","userButtonsContainer":"Header_userButtonsContainer__3nSHV","userFormBtn":"Header_userFormBtn__THTPn"};